import React from "react"
import VisitReportContainer from "../components/VisitReport/VisitReportContainer"
const VisitReportPage = props => {
  return <VisitReportContainer />
}

export default VisitReportPage
